import axios from 'axios';
import { STORES, bulkPut, clearStore, getByIndex } from './db';
import { API_BASE_URL } from '../api';

const LAST_SYNC_KEY = 'offlineCatalogLastSyncedAt';

export function getLastSyncedAt() {
    const raw = localStorage.getItem(LAST_SYNC_KEY);
    return raw ? new Date(raw) : null;
}

// Pulls a full snapshot of every sellable product (with batches, prices and
// stock) for the current pharmacy and replaces the local cache with it —
// called once at login and again every time connectivity comes back, so the
// cache never drifts far from reality.
export async function refreshCatalog() {
    const { data } = await axios.get(`${API_BASE_URL}/api/v1/cart/offline-catalog`, { withCredentials: true });
    await clearStore(STORES.CATALOG);
    await bulkPut(STORES.CATALOG, data);
    localStorage.setItem(LAST_SYNC_KEY, new Date().toISOString());
    return data.length;
}

// Mirrors the shape returned by GET /api/v1/cart/barcode/{barcode}, so Cart.js
// doesn't need to know whether it's looking at a live or cached result.
export async function lookupByBarcode(barcode) {
    const item = await getByIndex(STORES.CATALOG, 'barcode', barcode);
    if (!item) return { found: false };
    return { ...item, found: true };
}
